import React from 'react';
import { Col, Row } from 'react-bootstrap';
import ProfileBanner from '../ProfileBanner';
import ProfileDetails from './ProfileDetails';
import coverSrc from 'assets/img/generic/bg-profile.jpg';
import avatar from 'assets/img/generic/person.png';

const UserProfile = () => {
  return (
    <>
      <ProfileBanner>
        <ProfileBanner.Header
          coverSrc={coverSrc}
          avatar={avatar}
          className="mb-8"
        />
      </ProfileBanner>
      <Row className="g-3">
        <Col lg={8}>
          <ProfileDetails />
        </Col>
        <Col lg={4}>
          <div className="sticky-sidebar"></div>
        </Col>
      </Row>
    </>
  );
};

export default UserProfile;
